import HandleRoutes from 'layers/HandleRoutes';

export default class MeliaHandleRoutes extends HandleRoutes {
    updateRoutes(providedRoutes) {
        this.routes = providedRoutes;
        this.removeRoutes();
        this.createRoutes(providedRoutes);
        this.drawRoutes();
        this._bindEvents();
        if (this.drawLabel) {
          this._drawLabels();
        }
    }
}



// WEBPACK FOOTER //
// ./src/layers/MeliaHandleRoutes.js